import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../../auth.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
    constructor(private auth: AuthService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot) {
        const requiredRole: string = route.data['requiredRole'];

        return this.auth.loadUser().pipe(
            map((user) => {
                const roles = (user?.roles ?? []).map((r) => r.toLowerCase());

                if (requiredRole && roles.includes(requiredRole.toLowerCase())) {
                    return true;
                }

                return this.router.createUrlTree(['/access-denied']);
            }),
            catchError(() => of(this.router.createUrlTree(['/access-denied'])))
        );
    }
}
